import { Box, styled, Typography } from '@mui/material';

export const PermissionsBox = styled(Box)(() => ({
  marginTop: '32px',
}));

export const DisabledTypography = styled(Typography)(({ theme }) => ({
  color: theme.palette.action.disabled,
}));
